import { all } from 'redux-saga/effects'

//public
import loginSaga from './auth/login/saga';
import LayoutSaga from './layout/saga';



//Ecommerce saga

export default function* rootSaga() {
    yield all([

        //public
        loginSaga(),
        LayoutSaga(),
        
    ])
}